import { AccountContextService } from './account-context.service';
import { AuthAccountService } from './auth-account.service';
import { AuthRequestBuilderService } from './auth-request-builder.service';
import { AuthStateService } from './auth-state.service';
import { AuthSessionService } from './auth-session.service';
import { B2cAuthorityService } from './b2c-authority.service';
import { MsalConfigService } from './msal-config.service';
import { MsalStoragePolicyService } from './msal-storage-policy.service';
import { ProtectedResourceService } from './protected-resource.service';
import { TenantClaimResolverService } from './tenant-claim-resolver.service';
import { TenantUrlEnforcer } from './tenant-url-enforcer.service';

export * from './account-context.service';
export * from './auth-account.service';
export * from './auth-request-builder.service';
export * from './auth-state.service';
export * from './auth-session.service';
export * from './b2c-authority.service';
export * from './msal-config.service';
export * from './msal-storage-policy.service';
export * from './protected-resource.service';
export * from './tenant-claim-resolver.service';
export * from './tenant-url-enforcer.service';

export const SecurityDomainServices = [
    AccountContextService,
    AuthAccountService,
    AuthRequestBuilderService,
    AuthStateService,
    AuthSessionService,
    B2cAuthorityService,
    MsalConfigService,
    MsalStoragePolicyService,
    ProtectedResourceService,
    TenantClaimResolverService,
    TenantUrlEnforcer,
];
